<template>
  <div>
    <div class="tw-flex tw-flex-col tw-gap-2">
      <h1 class="tw-font-semibold tw-text-xl lg:tw-text-2xl xl:tw-text-3xl">Sign in</h1>
      <div class="tw-flex tw-flex-col tw-mt-0 lg:tw-mt-4 tw-gap-2">
        <p class="tw-font-medium tw-opacity-75 xl:tw-text-xl">Welcome to Forma-Diet</p>
        <p class="tw-text-xs tw-opacity-50 lg:tw-text-base">Please sign in to your account and start the adventure</p>
      </div>
    </div>
    <div class="lg:tw-mt-10 tw-mt-6">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="tw-flex tw-flex-col tw-w-full tw-gap-1 tw-text-sm">
            <label for="">Email Address or Phone Number</label>
            <ValidationProvider v-slot="{ errors }" name="Username" rules="required">
              <v-text-field v-model="phone" :error-messages="errors" label="Username" required outlined dense></v-text-field>
            </ValidationProvider>
          </div>
          <div class="tw-flex tw-flex-col tw-w-full tw-gap-1 tw-text-sm">
            <label for="">Password</label>
            <ValidationProvider v-slot="{ errors }" name="Password" rules="required">
              <v-text-field
                v-model="password"
                :error-messages="errors"
                label="Password"
                outlined
                required
                dense
                :append-icon="show1 ? 'mdi-eye dark--text' : 'mdi-eye-off dark--text'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div class=" tw-flex tw-justify-end">
            <v-btn type="submit" :loading="btn_loading" color="secondary" class="white--text tw-font-medium tw-px-8">SIGN IN</v-btn>
          </div>
        </form>
      </ValidationObserver>
      <p v-if="errorFromApi" class="mt-6 text-center red--text">
        {{ errorFromApi }}
      </p>
    </div>
  </div>
</template>

<script>
import { required, length } from "vee-validate/dist/rules";
import { userSignIn } from "../methods/signin.js";
import { isDietitian } from "../../user/methods/helper.js";

import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} cannot be empty",
});

extend("length", {
  ...length,
  message: "{_field_} number should have {length} digits",
});
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      show1: false,
      phone: "",
      password: "",
      btn_loading: false,
      errorFromApi: null,
      style: {
        borderStyle: { border: "0px solid black !important" },
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.observer.validate();
      // this.$store.state.signin = true;

      this.btn_loading = true;
      userSignIn(this.phone, this.password).then(data => {
        if (data) {
          // console.log(data);
          if (data === true) {
            this.btn_loading = false;
            if (isDietitian()) {
              this.$router.replace({ path: "appointments" });
            } else {
              this.$router.replace({ path: "dashboard" });
            }
          } else if (data.includes("NOT_FOUND")) {
            this.errorFromApi = this.$t("user.signIn.invalidLogin");
            this.btn_loading = false;
          }
        }
      });
    },
  },
};
</script>

<style>
.inputPhone input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.inputPhone input::-webkit-outer-spin-button,
.inputPhone input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.tw-flex.tw-flex-col.tw-gap-2 p {
  margin-bottom: 0 !important;
}
</style>
